import Vue from 'vue'
import Vuex from 'vuex'
import VuexPersistence from 'vuex-persist'
import * as modules from './modules'

const vuexLocal = new VuexPersistence({
  storage: window.localStorage
})

Vue.use(Vuex)
export default new Vuex.Store({
  plugins: [vuexLocal.plugin],
  modules
})



// WEBPACK FOOTER //
// ./src/store/index.js